import React from "react";

import { NavLink, useLocation } from "react-router-dom";

import { withSitecoreContext } from "@sitecore-jss/sitecore-jss-react";
import styles from "../style/layout_components/SidebarNavigation.module.scss";

const SidebarNavigation = (props) => {
  const location = useLocation();
  return (
    <aside className={styles.sidebar}>
      <nav>
        <ul>
          {props.fields.items &&
            props.fields.items
              .filter((d) => d.fields.link)
              .map((d, key) => {
                const activeClass = location.pathname.startsWith(d.fields.link.url) ? styles.active : "";
                return (
                  <li key={key}>
                    <NavLink
                      id={`sidebar_button_${key}`}
                      className={`${d.fields.icon?.value} ${activeClass}`}
                      exact
                      to={d.fields.link.url}
                    ></NavLink>
                  </li>
                );
              })}
        </ul>
      </nav>
    </aside>
  );
};

export default withSitecoreContext()(SidebarNavigation);
